import { CloudFunctionRates } from '@pretto/website/src/lib/apiRates/formatApiRates/types/cloudFunctionRates.types'

type AdvancedSimuRatesResult = {
  duration: number
  salary_max: number
  salary_min: number
  rate: number
  nb_mortgagors: number
}

type AdvancedSimuRates = {
  results: AdvancedSimuRatesResult[]
}

export const formatCloudFunctionRatesToAdvancedSimuRates = (
  marketRatesProfileLatest: CloudFunctionRates[]
): AdvancedSimuRates => ({
  results: marketRatesProfileLatest.reduce<AdvancedSimuRatesResult[]>((acc, rate) => {
    const { duration, salaryMax, salaryMin, averageRate, mortgagors } = rate

    if (
      typeof duration === 'number' &&
      typeof salaryMax === 'number' &&
      typeof salaryMin === 'number' &&
      typeof averageRate === 'number' &&
      typeof mortgagors === 'number'
    ) {
      acc.push({
        duration: duration / 12,
        nb_mortgagors: mortgagors,
        rate: averageRate,
        salary_max: Math.round(salaryMax / 12),
        salary_min: Math.round(salaryMin / 12),
      })
    }

    return acc
  }, []),
})
